import { takeEvery } from 'redux-saga/effects';
import { METROLOGY_MODULE } from '../../../configs/moduleNames';

import { LOAD_METROLOGY_DATA, SAVE_METROLOGY } from '../actions';

import loadMetrologyData from './loadMetrologyData';
import saveMetrology from './saveMetrology';

export default function* watchDashboard() {
  yield takeEvery(METROLOGY_MODULE + LOAD_METROLOGY_DATA, loadMetrologyData);
  yield takeEvery(METROLOGY_MODULE + SAVE_METROLOGY, saveMetrology);
}
